import React, { useContext, useState } from 'react';
import Memory from './Memory';
import MemoryStart from './MemoryStart';
import { MemoryLevelContext } from '../Context/MemoryLevelContext';

const MemorySteps = () => {

    const { cardsReady } = useContext(MemoryLevelContext);

  return (
    <>
        <MemoryStart />
        {cardsReady &&
            <Memory />
        }
    </>
  )
}

export default MemorySteps;
